import(/* webpackMode: "eager" */ "/home/tsagi/build/test/web-dist/app/[aroeven]/error.tsx");
